import React from 'react';
import type { GestureResponderEvent } from 'react-native';
import { XStack } from 'tamagui';

import { hitSlop } from '../componentHelpers';
import Switch, { type SwitchProps } from '../inputs/Switch';
import { type BaseRowProps, Row } from './Row';

export interface SwitchRowProps extends BaseRowProps {
    switchProps: SwitchProps;
}

/**
 * Row component with a switch control.
 * Use this for boolean settings or on/off toggles.
 */
export const SwitchRow = ({ switchProps, ...rowProps }: SwitchRowProps) => {
    const isDisabled = switchProps.disabled === true;

    const handleRowPress = () => {
        if (isDisabled) {
            return;
        }
        switchProps.onCheckedChange(!switchProps.isChecked);
    };

    const handleSwitchPress = (e: GestureResponderEvent) => {
        if (isDisabled) {
            return;
        }
        e.stopPropagation();
        switchProps.onCheckedChange(!switchProps.isChecked);
    };

    return (
        <Row
            {...rowProps}
            onPress={isDisabled ? undefined : handleRowPress}
            rightContent={
                <XStack
                    onPress={isDisabled ? undefined : handleSwitchPress}
                    {...hitSlop(8)}
                    paddingVertical={8}
                    paddingLeft={8}
                    pointerEvents={isDisabled ? 'none' : 'box-only'}
                >
                    <Switch {...switchProps} />
                </XStack>
            }
        />
    );
};
